import Swiper from 'swiper';

class BlockSliderMedias {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-medias__swiper', {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      preventInteractionOnTransition: true,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        1025: {
          slidesPerView: 2,
          spaceBetween: 24
        }
      }
    });
  }
}

export const blockSliderMedias = new BlockSliderMedias();
